import styled from 'styled-components';

export const StyledDoughnutChartCard = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-height: ${(props) => (props.isdashboard ? '140px !important' : '')};
  flex-direction: column;
  /* padding: 10px 0; */

  .chart-card {
    padding: 25px 35px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    min-height: ${(props) => (props.isdashboard ? '' : '21vh')};
    height: 100%;

    &.mini {
      max-height: 21.5vh;
    }

    &-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      &-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .title {
          color: #2f2f35;
          font-family: Poppins, sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-right: 8px;
        }

        .icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }
      }

      &-content {
        height: 35px;
        border-radius: 4px;
        padding: 5px 11px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2f2f35;
        font-family: Poppins, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        background-color: ${(props) =>
          props.bgColor
            ? 'rgba(' + props.bgColor.r + ',' + props.bgColor.g + ',' + props.bgColor.b + ',0.15)'
            : 'white'};
        overflow: revert;
        max-lines: 1;
      }
    }

    &-content {
      display: flex;
      justify-content: end;
      align-items: center;
      height: 90%;
      position: relative;

      &-legend {
        max-height: ${(props) => (props.isdashboard ? '160px' : '240px')};
        overflow-y: auto;
        position: absolute;
        right: ${(props) => (props.isdashboard ? '0' : '')};
        color: #2f2f35;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        ul {
          width: 250px !important;
        }
        li {
          display: flex;
          align-items: center;
          margin: 3px 0px;

          span.mr-auto {
            margin-left: auto;
          }
        }
      }
    }

    &-footer {
      margin-top: 30px;
    }
  }
`;
